export default class CloseMenu {
	static instance = null;

	static create() {
		if (!CloseMenu.instance) {
			CloseMenu.instance = new CloseMenu();
		}
		return CloseMenu.instance;
	}

	static destroy() {
		if (CloseMenu.instance) {
			CloseMenu.instance.beforeDestroy();
			CloseMenu.instance = null;
		}
	}

	constructor() {
		this.navopener = document.querySelector('.nav-opener');
		this.navwrap = document.querySelector('.nav-wrap');
		this.navout = 'nav-out';
		this.navactive = 'nav-active';
		this.init();
	}

	init() {
		this.initCloseMenu();
	}

	initCloseMenu() {
		$('#smooth-wrapper').on('click touchstart pointerdown MSPointerDown', (e) => {
			var target = $(e.target);
			if (!target.closest(this.navopener).length && !target.closest(this.navwrap).length) {
				if ($('body').hasClass('nav-active')) {
					$('body').toggleClass(this.navactive);
					$('body').addClass(this.navout);
					setTimeout(() => {
						$('body').removeClass(this.navout);

					}, 1001);
				}


			}
		});
	}

	beforeDestroy() {
		$('html').off('click touchstart pointerdown MSPointerDown');
	}
}
